import { render, staticRenderFns } from "./Infotip.vue?vue&type=template&id=fa618082&scoped=true"
import script from "./Infotip.vue?vue&type=script&lang=js"
export * from "./Infotip.vue?vue&type=script&lang=js"
import style0 from "./Infotip.vue?vue&type=style&index=0&id=fa618082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa618082",
  null
  
)

export default component.exports